<div class="flex h-screen">
  <app-wg-sidebar (sidebarClicked)="sidebarChanged($event)"></app-wg-sidebar>
  <div class="flex-1 flex flex-col min-w-0">
    <app-wg-header></app-wg-header>
    <div class="flex-1 overflow-auto wg-scroll-container" cdkScrollable>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<!-- OLD LAYOUT (kept for rollback):
<div class="main-content" [className]="sidebarMenuOpened ? 'main-content' : 'main-content collapsed'">
    <app-sem-left-menu #leftMenu (sidebarClicked)="sidebarChanged($event)"></app-sem-left-menu>
    <app-sem-header-menu [com1ref]="leftMenu" #headerMenu></app-sem-header-menu>
    <router-outlet></router-outlet>
</div>
-->
